import { createFileRoute, notFound } from "@tanstack/react-router";
import leagueStyles from "../styles/use-case-league.css?url";
import { withStylesheet } from "../lib/head";
import { platformPageHead, platformShellFrom } from "../platform/head";
import { loadLeagueOtp } from "../platform/use-cases";
import { LeagueOtpPage } from "../platform/use-cases/league-otp";

/** The League OTP Bible template's own page (Drate's host only). */
export const Route = createFileRoute("/use-cases/league-otp-bible")({
  loader: async () => {
    const page = await loadLeagueOtp();
    if (!page) throw notFound();
    return page;
  },
  head: ({ matches, loaderData }) =>
    loaderData
      ? withStylesheet(
          platformPageHead(platformShellFrom(matches), {
            pathname: "/use-cases/league-otp-bible",
            title: "Sell League of Legends matchup guides as a membership | Drate",
            description:
              "Turn your League of Legends expertise into searchable matchup guides, a structured Bible and a membership. Champion, item and rune data stays current.",
            structuredData: loaderData.structuredData,
          }),
          leagueStyles,
        )
      : {},
  component: () => <LeagueOtpPage page={Route.useLoaderData()} />,
});
